module.exports = __webpack_public_path__ + "f2a6e1553081855ef3d87f56f51f2925.jpg";